// extracted by mini-css-extract-plugin
export var container = "_5n-1";
export var cornerButtonContainer = "_5n-5";
export var disabled = "_5n-2";
export var fileContainer = "_5n-4";
export var hiddenInput = "_5n-3";
export var widthContainer = "_5n-0";